import GoogleBigQueryReaderNode from './types/google-big-query-reader';
import GoogleBigQueryWriterNode from './types/google-big-query-writer';
import GoogleSpreadsheetReaderNode from './types/google-spreadsheet-reader';
import GoogleSpreadsheetWriterNode from './types/google-spreadsheet-writer';

export const googleSpreadsheetNodes = {
  googleSpreadsheetReader: GoogleSpreadsheetReaderNode,
  googleSpreadsheetWriter: GoogleSpreadsheetWriterNode,
  googleBigQueryReader: GoogleBigQueryReaderNode,
  googleBigQueryWriter: GoogleBigQueryWriterNode,
};
